import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "status", "input"]
  static values = {
    provider: String,
    msgTyping: { type: String, default: "입력 중..." },
    msgLoading: { type: String, default: "검증 중..." },
    msgSuccess: { type: String, default: "연결 확인됨" },
    msgErrorConnection: { type: String, default: "연결 실패" },
    msgErrorNetwork: { type: String, default: "네트워크 오류가 발생했습니다." }
  }

  connect() {
    this.timeout = null
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  // 입력 변경 시 800ms debounce 후 자동 검증
  onInput() {
    clearTimeout(this.timeout)
    this.setStatus("typing", this.msgTypingValue)
    this.timeout = setTimeout(() => {
      if (this.hasInputTarget && this.inputTarget.value.trim().length > 10) {
        this.verify()
      }
    }, 800)
  }

  async verify() {
    const provider = this.providerValue
    this.setStatus("loading", this.msgLoadingValue)

    if (this.hasButtonTarget) this.buttonTarget.disabled = true

    try {
      const res = await fetch("/dashboard/ai_credentials/verify", {
        method: "POST",
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          provider,
          api_key: this.hasInputTarget ? this.inputTarget.value : ""
        })
      })
      const data = await res.json()

      if (data.success) {
        this.setStatus("success", data.message || this.msgSuccessValue)
      } else {
        this.setStatus("error", data.message || this.msgErrorConnectionValue)
      }
    } catch (e) {
      this.setStatus("error", this.msgErrorNetworkValue)
    } finally {
      if (this.hasButtonTarget) this.buttonTarget.disabled = false
    }
  }

  setStatus(type, message) {
    if (!this.hasStatusTarget) return
    const icons = { loading: "", success: "", error: "", typing: "" }
    const colors = {
      loading: "text-gray-500",
      success: "text-green-600",
      error: "text-red-600",
      typing: "text-gray-400"
    }
    this.statusTarget.textContent = `${icons[type]} ${message}`
    this.statusTarget.className = `text-sm mt-1 ${colors[type]}`
  }
}
